<template>
    <section class="main" style="position: relative" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">

        <div style="position: absolute; top: 16px; right: 16px;z-index: 2" class="hovered">
            <v-btn icon @click="openInput">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <v-btn icon @click="$emit('move_row_up')">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_down')">
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <v-menu top left>
                <template v-slot:activator="{ on }">
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>

                </template>
                <v-list>

                    <v-list-item @click="$emit('copy_main_block')">
                        <v-list-item-title>Копировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="settings = true">
                        <v-list-item-title>Редактировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('block-delete')">
                        <v-list-item-title>Удалить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <v-dialog
                v-model="settings"
                max-width="600px"
                scrollable
        >
            <youtube-block-settings v-model="block" @close-settings="settings = false"></youtube-block-settings>

        </v-dialog>

        <v-container>
            <v-row>
                <v-col cols="12" class="main"  >
                    <div class="iframe-container">
                        <iframe :width="size.width" :height="size.height" :src="'https://www.youtube.com/embed/' + rightLink" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>

                        </iframe>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <v-overlay :value="videoInput">
            <video-input :closer="closeInput" @url="changeURL"></video-input>
        </v-overlay>

    </section>
</template>

<script>
    import videoInput from "./videoInput";
    import YoutubeBlockSettings from "./YoutubeBlockSettings";

    export default {
        props:["block"],
        components:{
            videoInput,
            YoutubeBlockSettings
        },
        name: "YoutubeBlock",
        data(){
            return{
                videoInput: false,
                settings: false
            }
        },
        computed: {
            rightLink(){
                var kek = this.block.url.slice(32)
                return kek
            },
            size() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return {
                        width: 250,
                        height: 130
                    }
                    case 'sm': return {
                        width: 300,
                        height: 160
                    }
                    case 'md':
                        return {
                            width: 560,
                            height: 315
                        }
                    case 'lg':
                        return {
                            width: 1000,
                            height: 500
                        }
                    case 'xl':
                        return {
                            width: 1000,
                            height: 500
                        }
                }
                return false
            }
        },
        methods:{
            changeURL(data){
                this.block.url = data
            },
            closeInput(){
                this.videoInput = false
            },
            openInput(){
                this.videoInput = true
            },
            openPaddingControls(e){
                this.paddingControl.x = e.clientX;
                this.paddingControl.y = e.clientY;
                this.paddingControl.paddingContols = true;
            }
        },
        mounted(){
            if(this.block.url == ""){
                this.openInput()
            }
        }


    }
</script>

<style scoped>
    .main{
        position: relative;
    }

    .iframe-container{
        margin: 0 auto;
        width: fit-content;
    }

    .color-picker-closer{
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
    }

    .color-picker{
        position: absolute;
        z-index: 100;
        bottom: 0;
        right: 0
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

</style>